import { AuthManager } from "../../component/auth/AuthContext";
import * as React from "react";
import { Component } from "react";
import { RouteComponentProps } from "react-router";
import EvalWorkflowApi, { EvalWorkflow } from "../../api/EvalWorkflowApi";
import MessageService from "../../service/MessageService";
import { Button } from "reactstrap";
import i18n from "i18next";

interface ReaderWelcomeProps extends RouteComponentProps {
  authManager: AuthManager;
}

interface ReaderWelcomeState {
  evalCode?: string;
  readerWorkflow?: EvalWorkflow;
}

export default class ReaderWelcome extends Component<ReaderWelcomeProps, ReaderWelcomeState> {
  private evalWorkflowApi: EvalWorkflowApi;

  constructor(props: ReaderWelcomeProps) {
    super(props);
    this.evalWorkflowApi = EvalWorkflowApi.with(this.props.authManager.cancelableClient());
    this.state = {};
  }

  componentDidMount(): void {
    this.evalWorkflowApi.findEval(EvalWorkflow.RD).then((evaluation) => {
      if (evaluation) {
        this.setState({ evalCode: evaluation.code, readerWorkflow: EvalWorkflow.RD });
      } else {
        this.evalWorkflowApi.findEval(EvalWorkflow.RD_AI).then((evaluation) => {
          if (evaluation) {
            this.setState({ evalCode: evaluation.code, readerWorkflow: EvalWorkflow.RD_AI });
          } else {
            MessageService.info(i18n.t("global.noEval"));
          }
        });
      }
    });
  }

  render() {
    return (
      <div className="container">
        <h1>{i18n.t("RD.title")}</h1>

        {this.state.readerWorkflow == EvalWorkflow.RD && <p>{i18n.t("RD.noAIDesc")}</p>}
        {this.state.readerWorkflow == EvalWorkflow.RD_AI && <p>{i18n.t("RD.AIDesc")}</p>}

        <Button onClick={() => this.startWorkflow(this.state.readerWorkflow)} disabled={!this.state.evalCode}>
          {i18n.t("global.start")}
        </Button>
      </div>
    );
  }

  private startWorkflow(readerWorkflow: EvalWorkflow) {
    this.props.history.push("/reader-workflow?" + this.buildParamStr());
  }

  private buildParamStr() {
    const params = new URLSearchParams();
    params.append("evalCode", this.state.evalCode);
    params.append("readerWorkflow", this.state.readerWorkflow);
    return params.toString();
  }
}
